import { Task, Comment } from '../types';
import { htmlToPlainText, isEmptyHtml } from './sanitizeHtml';

export function getLatestComment(task: Task): Comment | null {
  if (!task.comments?.length) return null;
  return [...task.comments].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )[0];
}

export function commentPreviewText(comment: Comment): string {
  if (!isEmptyHtml(comment.text)) {
    const plain = htmlToPlainText(comment.text);
    if (plain) return plain;
  }
  if ((comment.attachments?.length ?? 0) > 0) {
    const name = comment.attachments![0].originalName;
    const extra = comment.attachments!.length > 1 ? ` (+${comment.attachments!.length - 1})` : '';
    return `📎 ${name}${extra}`;
  }
  return '';
}

export function getTaskLastCommentPreview(task: Task): { comment: Comment; text: string } | null {
  const comment = getLatestComment(task);
  if (!comment) return null;
  const text = commentPreviewText(comment);
  if (!text) return null;
  return { comment, text };
}
